/* PB Liquids Desk

   Wat de desktopindeling nodig heeft en wat CSS niet kan.

   DRIE DINGEN:

     1. De ladder en de picker in één kolom zetten. Het zijn twee secties en dus
        twee buren in de DOM; een omhulsel om ze allebei bestaat in Liquid niet,
        en zonder dat kan de indeling ze niet als één ding naast de foto zetten.
        De sectie zelf doet dit al bij het parsen — zie het scriptje onderaan
        sections/pb-liquids-desk.liquid — zodat de bezoeker de mobiele stapeling
        niet even ziet staan. Hier staat het nog een keer, want de theme-editor
        kan een sectie opnieuw plaatsen en dan staat hij weer naast de kolom in
        plaats van erin.

     2. De hoogte van de navigatie meten. De blauwe band is zo hoog als wat er
        onder de navigatie overblijft, en hoe hoog die is weet alleen de
        browser.

     3. De ladder met klikken laten werken. Op desktop staat hij bovenaan een
        kolom die je in één blik ziet, en dan is er geen scrollverhaal om te
        volgen. Boven het breekpunt gaat die controller daarom uit en nemen we
        de tredes over: één klik, één trede. Eronder krijgt hij ze terug.

     Plus: de ladder passend maken op wat er van het eerste scherm overblijft.

   HET BREEKPUNT KOMT UIT DE SECTIE en staat op data-pbdk-break. Dezelfde
   waarde staat in het media-attribuut van de stylesheet, dus de twee schakelen
   op dezelfde breedte. */
(function () {
  'use strict';

  if (window.PBLiquidsDesk) {
    window.PBLiquidsDesk.init(document);
    return;
  }

  var controllers = new WeakMap();

  function findSections(root) {
    var found = [];

    if (root.matches && root.matches('[data-pbdk-section]')) found.push(root);
    if (root.querySelectorAll) {
      found = found.concat(
        Array.prototype.slice.call(root.querySelectorAll('[data-pbdk-section]'))
      );
    }

    return found;
  }

  function createController(section) {
    var host = section.closest('main') || document.getElementById('MainContent');
    if (!host) return null;

    var breakpoint = parseInt(section.getAttribute('data-pbdk-break'), 10);
    if (!breakpoint || breakpoint < 600 || breakpoint > 2000) breakpoint = 1100;

    var start = parseInt(section.getAttribute('data-pbdk-start'), 10);
    if (!start || start < 1) start = 1;

    var peek = parseInt(section.getAttribute('data-pbdk-peek'), 10);
    if (isNaN(peek) || peek < 0 || peek > 400) peek = 24;

    var query = window.matchMedia('(min-width: ' + breakpoint + 'px)');
    var wide = false;
    var rows = [];
    var ladder = null;
    var frame = 0;
    var watcher = null;

    /* ----------------------------------------------------------------------
       Het scrollvak
       ---------------------------------------------------------------------- */

    function wrap() {
      var ladderSection = host.querySelector('.section-pb-bundle-ladder-scroll');
      var pickerSection = host.querySelector('.pb-liquid-picker-section');
      if (!ladderSection || !pickerSection) return null;

      var track = host.querySelector('[data-pbdk-track]');

      if (!track) {
        track = document.createElement('div');
        track.className = 'pb-liquids-desk__track';
        track.setAttribute('data-pbdk-track', '');
        track.innerHTML =
          '<div class="pb-liquids-desk__panel" data-pbdk-panel>' +
          '<div class="pb-liquids-desk__scroll" data-pbdk-scroll></div>' +
          '</div>';
        ladderSection.parentNode.insertBefore(track, ladderSection);
      }

      var scroll = track.querySelector('[data-pbdk-scroll]');

      /* Alleen verplaatsen wat nog niet staat waar het hoort: een sectie
         verhuizen laadt zijn iframes en video's opnieuw, en de theme-editor
         roept dit bij elke wijziging aan. */
      if (ladderSection.parentNode !== scroll) scroll.appendChild(ladderSection);
      if (pickerSection.parentNode !== scroll) scroll.appendChild(pickerSection);

      /* Pop stars in zijn plakkende omhulsel — zie stars() hieronder. Op de
         plek waar de sectie al stond, zodat de mobiele volgorde blijft. */
      var starsSection = host.querySelector('.section-pb-pop-stars');
      var shell = host.querySelector('[data-pbdk-stars]');
      if (starsSection && !shell) {
        shell = document.createElement('div');
        shell.className = 'pb-liquids-desk__stars';
        shell.setAttribute('data-pbdk-stars', '');
        starsSection.parentNode.insertBefore(shell, starsSection);
      }
      if (starsSection && shell && starsSection.parentNode !== shell) {
        shell.appendChild(starsSection);
      }

      host.classList.add('pb-liquids-desk-ready');

      return scroll;
    }

    /* ----------------------------------------------------------------------
       De navigatie, twee keer gemeten

       De header-groep zegt waar <main> begint. Maar de balk die de bezoeker
       ziet zweeft daar los overheen — `position: fixed`, buiten de flow — en
       reikt een heel eind lager. Meet je alleen de eerste, dan begint de hero
       onder die balk.

       offsetTop en niet getBoundingClientRect voor die zwevende balk: hij
       schuift bij het scrollen uit beeld met een transform, en een rect telt
       die mee. offsetTop is waar hij staat als hij er is.
       ---------------------------------------------------------------------- */

    function measure() {
      var header =
        document.getElementById('header-group') ||
        document.querySelector('.shopify-section-group-header-group');

      var height = header ? Math.round(header.getBoundingClientRect().height) : 0;
      if (height <= 0) return;

      var root = document.documentElement.style;
      root.setProperty('--pbdk-header', height + 'px');

      var floating = document.querySelector('.pb-unified-nav__fixed');
      var bottom = height;

      if (floating && floating.offsetHeight) {
        bottom = Math.max(bottom, Math.round(floating.offsetTop + floating.offsetHeight));
      }

      root.setProperty('--pbdk-nav', bottom + 'px');
    }

    /* ----------------------------------------------------------------------
       De inhoud van de kolom op de scrollstand zetten

       De kolom staat stil zolang het spoor eronder langskomt. Wat er in haar
       te zien is hangt dus alleen nog af van hoe ver de pagina gescrold is:
       één pixel pagina is één pixel inhoud, zodat het aanvoelt als gewoon
       scrollen en niet als een effect.

       De hoogte van het spoor is precies hoeveel de inhoud langer is dan de
       kolom. Groeit de inhoud — de picker zet stappen open zodra er blikjes in
       gaan — dan groeit het spoor mee, en dat weet alleen de browser, vandaar
       de ResizeObserver.
       ---------------------------------------------------------------------- */

    function parts() {
      var track = host.querySelector('[data-pbdk-track]');
      var panel = track && track.querySelector('[data-pbdk-panel]');
      var scroll = panel && panel.querySelector('[data-pbdk-scroll]');
      return scroll ? { track: track, panel: panel, scroll: scroll } : null;
    }

    function travelOf(bits) {
      return Math.max(0, bits.scroll.offsetHeight - bits.panel.clientHeight);
    }

    /* Waar de pagina staat op het moment dat de kolom vast komt te staan. */
    function pinnedAt(bits) {
      var style = getComputedStyle(bits.panel);
      var top = bits.track.getBoundingClientRect().top + (window.pageYOffset || 0);
      return top + (parseFloat(style.marginTop) || 0) - (parseFloat(style.top) || 0);
    }

    function sync() {
      frame = 0;
      if (!wide) return;

      var bits = parts();
      if (!bits) return;

      var travel = travelOf(bits);
      var at = (window.pageYOffset || 0) - pinnedAt(bits);

      bits.scroll.style.top = -Math.max(0, Math.min(travel, at)) + 'px';

      /* Hoeveel er gescrold is nádat de kolom klaar is. Zolang dit 0 is staat
         de kop van de pagina stil — de aankondigingsbalk plakt bovenaan en de
         navigatiebalk houdt zijn plek eronder. Daarna schuiven ze samen weg,
         precies zo snel als de pagina. Zie de kop van pb-liquids-desk.css.

         Op documentElement en niet op de sectie: de balken staan buiten <main>
         en zien de eigenschap alleen daar. */
      document.documentElement.style.setProperty(
        '--pbdk-headroll',
        Math.max(0, at - travel) + 'px'
      );
    }

    function onScroll() {
      if (frame) return;
      frame = window.requestAnimationFrame(sync);
    }

    function measureTravel() {
      var bits = parts();
      if (!bits) return;

      if (!wide) {
        bits.track.style.removeProperty('--pbdk-travel');
        bits.scroll.style.removeProperty('top');
        document.documentElement.style.removeProperty('--pbdk-headroll');
        return;
      }

      bits.track.style.setProperty('--pbdk-travel', travelOf(bits) + 'px');
      sync();
    }

    /* Iemand die met Tab door de kaarten loopt komt vanzelf bij een knop die
       buiten de kolom valt. De kolom knipt en scrollt niet, dus daar gebeurt
       vanzelf niets — die knop zou onzichtbaar de focus krijgen. Dit schuift in
       plaats daarvan de pagina, en sync legt de inhoud daar weer op. */
    function onFocus(event) {
      var bits = parts();
      if (!wide || !bits || !event.target || !event.target.getBoundingClientRect) return;
      if (!bits.scroll.contains(event.target)) return;

      var seen = bits.panel.getBoundingClientRect();
      var here = event.target.getBoundingClientRect();
      var air = 24;

      if (here.top >= seen.top + air && here.bottom <= seen.bottom - air) return;

      window.scrollBy(
        0,
        here.top < seen.top + air
          ? here.top - seen.top - air
          : here.bottom - seen.bottom + air
      );
    }

    /* ----------------------------------------------------------------------
       De ladder passend maken

       DE LADDER HEEFT OP ELK SCHERM DEZELFDE MAAT: die waarop hij in de kolom
       van een groot scherm past. Zie het blok bij `tallest` hieronder — op een
       lager scherm loopt hij onderaan onder de golf en de vouw door.

       Meten en niet rekenen: hoe hoog de ladder is hangt af van hoeveel tredes
       er in de customizer staan, en dat kan morgen anders zijn. Zijn hoogte is
       wel netjes affien in --pbll-u (alles erin is een veelvoud daarvan, op de
       vaste padding na), dus twee metingen leggen het verband exact vast en de
       derde waarde is meteen goed.

       De maat die de CSS zelf zou kiezen lezen we van de badge af: die is
       --pbll-badge-raw keer --pbll-u, en dat is de enige manier om aan een
       custom property als getal te komen — getComputedStyle geeft de tekst
       "min(calc(...), 1.3px)" terug en niet wat daaruit volgt.
       ---------------------------------------------------------------------- */

    function unitOf(ladder) {
      var badge = ladder.querySelector('[data-pbll-badge]');
      if (!badge) return 0;

      var raw = parseFloat(getComputedStyle(ladder).getPropertyValue('--pbll-badge-raw'));
      if (!raw || raw <= 0) raw = 62;

      return badge.getBoundingClientRect().width / raw;
    }

    function fitLadder() {
      var scroll = host.querySelector('[data-pbdk-scroll]');
      var ladderSection = scroll && scroll.querySelector('.section-pb-bundle-ladder-scroll');
      var ladder = ladderSection && ladderSection.querySelector('.pb-bundle-ladder');
      if (!ladder) return;

      /* Onder het breekpunt is er geen vlak om in te passen: de ladder krijgt
         zijn eigen maat terug. */
      if (!wide) {
        ladder.style.removeProperty('--pbll-u');
        return;
      }

      /* DE LADDER HEEFT OP ELK SCHERM DEZELFDE MAAT: die van een groot scherm.
         Eerst paste hij in de kolom zoals die op dít scherm is. Op een laptop
         (venster ±800 hoog) is die kolom 580 hoog en kwam de ladder op zijn
         bodem van 0,72 uit — te klein om te lezen, vond Brent, terwijl de maat
         op een groot scherm precies goed is. Daar is de kolom zo hoog als het
         eerste scherm maximaal wordt (--pbdk-stage-max), en dát is nu overal
         de kolom waar de ladder in past. Op een lager scherm loopt hij onderaan
         onder de golf en de vouw door; de inhoud van de kolom schuift bij het
         scrollen omhoog, dus wat eronder staat komt gewoon in beeld.

         Gerekend en niet gemeten: de kolom op een groot scherm is
         stage-max − top − voet, met top = stage-max × top-share (zie
         --pbdk-panel-height in de stylesheet). De waarden staan als getal op
         :root, dus zijn ze hier te lezen. */
      var rootStyle = getComputedStyle(document.documentElement);
      var stageMax = parseFloat(rootStyle.getPropertyValue('--pbdk-stage-max')) || 900;
      var topShare = parseFloat(rootStyle.getPropertyValue('--pbdk-top-share')) || 0.082;
      var footAir = parseFloat(rootStyle.getPropertyValue('--pbdk-foot')) || 24;
      var tallest = stageMax * (1 - topShare) - footAir;

      /* Min wat de golf van de kolom afdekt: die ligt over de onderkant van de
         kolom (--pbdk-dip, de halve golfhoogte), en wat daaronder staat ziet
         de bezoeker niet. Gemeten aan de golf zelf, zodat een uitgezette golf
         (geen element) hier gewoon nul oplevert. */
      var foot = host.querySelector('[data-pbdk-foot]');
      var dip = foot ? foot.offsetHeight / 2 : 0;

      var room = tallest - dip - peek;
      if (room <= 0) return;

      function heightAt(u) {
        ladder.style.setProperty('--pbll-u', u + 'px');
        return ladderSection.getBoundingClientRect().height;
      }

      /* Eerst terug naar wat de CSS wil: dat is het plafond, want passend
         maken mag hem kleiner maken en nooit groter. */
      ladder.style.removeProperty('--pbll-u');

      var ceiling = unitOf(ladder);
      if (!ceiling) return;
      if (ladderSection.getBoundingClientRect().height <= room) return;

      /* Zoeken in plaats van in één keer uitrekenen. De hoogte is stuksgewijs
         recht in --pbll-u en niet in één rechte lijn: alles wat tegen de rand
         van het frame staat — de kop, de voetnoten — schaalt mee tot 402/378 en
         daarboven niet meer. Een helling die over die knik heen gemeten wordt
         klopt aan geen van beide kanten, dus meten we hem telkens opnieuw vlak
         bij waar we zitten. Drie rondes zijn ruim genoeg. */
      var u = ceiling;

      for (var i = 0; i < 3; i++) {
        var high = heightAt(u);
        if (Math.abs(high - room) <= 4) break;

        var probe = u * 0.9;
        var slope = (high - heightAt(probe)) / (u - probe);
        if (!(slope > 0)) break;

        var next = u + (room - high) / slope;

        /* Nooit groter dan wat de CSS wilde, en niet zo klein dat de ladder
           onleesbaar wordt — dan mag hij liever uit het vlak lopen. 0,72 is een
           vaste bodem en geen percentage van het plafond: hoe klein te klein is
           hangt af van de letters, niet van hoe breed het vlak toevallig is. Op
           die maat is een badge 45px en de kop 19px; het eerste desktopontwerp
           tekende de badges op 51, dus veel lager hoeft het niet. */
        next = Math.min(ceiling, Math.max(0.72, next));
        if (Math.abs(next - u) < 0.004) {
          u = next;
          break;
        }

        u = next;
      }

      ladder.style.setProperty('--pbll-u', u + 'px');
    }

    /* ----------------------------------------------------------------------
       De ladder met klikken
       ---------------------------------------------------------------------- */

    function setTier(index) {
      rows.forEach(function (row, i) {
        var on = i === index;
        row.classList.toggle('is-active', on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function pick(event) {
      var row = event.target.closest ? event.target.closest('[data-pbll-row]') : null;
      var index = rows.indexOf(row);
      if (index === -1) return;

      /* De aanwijzing "klik mij!" heeft zijn werk gedaan zodra er geklikt is. */
      if (ladder) ladder.setAttribute('data-pbdk-picked', '');

      setTier(index);
    }

    function onKey(event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

      var row = event.target.closest ? event.target.closest('[data-pbll-row]') : null;
      if (rows.indexOf(row) === -1) return;

      event.preventDefault();
      pick(event);
    }

    function clickMode(on) {
      ladder = host.querySelector('[data-pbll-scroll-ladder]');
      if (!ladder) return;

      rows = Array.prototype.slice.call(ladder.querySelectorAll('[data-pbll-row]'));
      if (!rows.length) return;

      if (on) {
        if (ladder.hasAttribute('data-pbdk-click')) return;

        /* De scroll-controller eerst weg, anders vecht hij bij elke
           venster-scroll de klik weer terug. */
        if (window.PBBundleLadderScroll) window.PBBundleLadderScroll.destroy(ladder);

        ladder.setAttribute('data-pbdk-click', '');
        rows.forEach(function (row) {
          row.setAttribute('role', 'button');
          row.setAttribute('tabindex', '0');
        });

        setTier(Math.min(start - 1, rows.length - 1));
        ladder.addEventListener('click', pick);
        ladder.addEventListener('keydown', onKey);
        return;
      }

      if (!ladder.hasAttribute('data-pbdk-click')) return;

      ladder.removeAttribute('data-pbdk-click');
      ladder.removeAttribute('data-pbdk-picked');
      ladder.removeEventListener('click', pick);
      ladder.removeEventListener('keydown', onKey);
      rows.forEach(function (row) {
        row.removeAttribute('role');
        row.removeAttribute('tabindex');
        row.removeAttribute('aria-pressed');
      });

      /* Terug naar het scrollverhaal. De controller is weggegooid, dus init
         maakt een nieuwe — die zet de ladder zelf in zijn ruststand. */
      if (window.PBBundleLadderScroll) window.PBBundleLadderScroll.init(ladder);
    }

    /* ----------------------------------------------------------------------
       Het productblad zit op desktop ín de foto

       Op een telefoon komt het blad van onderen over de pagina, met een
       verduistering erachter. Op desktop is er iets beters: de foto links staat
       er toch al, doet niets, en is precies zo groot als het blad moet zijn.
       Dus gaat het blad de foto in, en wordt de foto het blad — het scrolt mee,
       de kolom schuift er overheen zoals over de foto, en de ronding van de foto
       knipt het.

       Dat is niet de eerste versie. Die zette het blad `fixed` op de gemeten
       maten van de foto, met een gastheer onder <body>, omdat het blad in de
       kolom onder pop stars zou verdwijnen. Drie dingen gingen daar mis: de
       kolom liet in haar ronde hoek de foto zien naast het blad, bij het
       scrollen liep het blad een frame achter op de foto, en zodra de foto weg
       was bleef het blad boven in beeld hangen. In de foto is er niets te
       meten en niets dat kan achterlopen.

       Waarom het niet meteen zo was: buiten `.pb-liquid-picker` erft het blad
       geen van de --pblp-kleuren, die de sectie als inline stijl meegeeft — dan
       is de kaart niet crème en de knop niet koraal. Vandaar een gastheer ín de
       foto met de klassen van de picker en diens inline stijl overgenomen.
       `display: contents` maakt van die gastheer geen doos; hij is er alleen om
       de --pblp-waarden door te geven.

       Wat er niet met CSS te doen is: de knop met "Toevoegen" en het telbalkje
       staan buiten het slot — ze moeten de wissel van inhoud overleven — maar
       horen in dit ontwerp binnen de kaart, op dezelfde regel als de prijs.
       ---------------------------------------------------------------------- */

    var sheetWatcher = null;
    var sheetHost = null;
    var sheetHome = null;

    /* Het element zelf onthouden en niet elke keer opnieuw zoeken. Zodra het in
       de kaart ligt, ruimt de picker het bij het sluiten mee op — hij maakt het
       slot leeg, en de kaart hangt daarin. Dan is het uit het document weg en
       vindt querySelector het niet meer, terwijl de picker er wél mee blijft
       werken. Met een eigen verwijzing hangen we het gewoon weer terug.

       Maar wel per blad: `sheetOwner` is het blad waar de knop bij hoort. De
       theme-editor bouwt de pickersectie bij elke wijziging opnieuw, met een
       nieuw blad en een nieuwe knop, terwijl het oude blad hier in de foto
       blijft hangen. Eén keer onthouden en nooit meer kijken betekende: de
       oude knop in de nieuwe kaart hangen, de nieuwe knop los in het blad
       laten staan, en de MutationObserver op het oude blad laten luisteren —
       "Toevoegen" stond dan naast de kaart in plaats van erin. */
    var sheetControl = null;
    var sheetOwner = null;

    /* Het blad van de picker die nu op de pagina staat. Niet het eerste
       `[data-pblp-sheet]` in het document: na een herlaad in de editor staat
       daar het oude blad, verborgen, nog in de foto. De picker onthoudt zijn
       eigen blad en zijn eigen knop op zijn sectie-element (`pbLiquidPicker`,
       zie assets/pb-liquid-picker.js); zonder die instantie — het script is
       nog niet zover — geldt het laatste blad in het document, en dat is het
       nieuwste. */
    function sheetParts() {
      var section = host.querySelector('[data-pblp-section]');
      var picker = section && section.pbLiquidPicker;
      var sheet = picker && picker.sheet;
      if (!sheet) {
        var sheets = document.querySelectorAll('[data-pblp-sheet]');
        sheet = sheets.length ? sheets[sheets.length - 1] : null;
      }
      if (!sheet) return null;

      if (sheetOwner !== sheet || !sheetControl) {
        sheetControl = (picker && picker.sheetControl) || sheet.querySelector('[data-pblp-sheet-control]');
        sheetOwner = sheet;
      }

      return {
        sheet: sheet,
        slot: sheet.querySelector('[data-pblp-sheet-slot]'),
        control: sheetControl,
        hero: host.querySelector('.pb-liquids-desk__hero'),
      };
    }

    /* De knop hoort in de kaart zodra die er staat, en weer in het blad zodra
       het slot leeg is. Dat tweede is niet netjesheid maar noodzaak: bij het
       sluiten maakt de picker het slot leeg, en de knop gaat dan als deel van
       de kaart mee het document uit. */
    function tuckControl(bits) {
      var body = bits.slot.querySelector('.pb-liquid-picker__sheet-body');
      var where = body || bits.sheet;
      if (bits.control.parentNode !== where) where.appendChild(bits.control);
    }

    /* De gastheer in de foto. Eén keer gemaakt, en de kleuren komen van de
       picker zelf: die zet ze als inline stijl op zijn <section>, dus staat
       dezelfde regel hier — en wordt elke keer overgenomen, want in de editor
       verandert die stijl met de instellingen mee. */
    function hostFor(sheet, hero) {
      var picker = host.querySelector('[data-pblp-section]') || sheet.closest('[data-pblp-section]');

      if (!sheetHost || sheetHost.parentNode !== hero) {
        sheetHost = document.createElement('div');
        sheetHost.className =
          'pb-liquid-picker pb-liquids-desk-ready pb-liquids-desk__sheet-host';
        sheetHost.setAttribute('data-pbdk-sheet-host', '');
        hero.appendChild(sheetHost);
      }
      if (picker && picker.getAttribute('style')) {
        sheetHost.setAttribute('style', picker.getAttribute('style'));
      }
      return sheetHost;
    }

    /* Een blad dat niet meer bij een picker hoort — de editor heeft zijn sectie
       vervangen — hoort ook niet meer in de foto. Weg ermee, anders stapelen
       ze zich op en vindt de volgende zoektocht de verkeerde. */
    function dropStaleSheets(keep) {
      if (!sheetHost) return;
      Array.prototype.slice.call(sheetHost.querySelectorAll('[data-pblp-sheet]')).forEach(function (old) {
        if (old !== keep && old.parentNode) old.parentNode.removeChild(old);
      });
    }

    function sheetMode(on) {
      var bits = sheetParts();
      if (!bits || !bits.slot || !bits.control) return;

      /* Een ander blad dan waar het thuisadres en de waarnemer voor waren: de
         sectie is herladen. Alles wat aan het vorige blad hing gaat opnieuw. */
      if (sheetHome && sheetHome.sheet !== bits.sheet) {
        sheetHome = null;
        if (sheetWatcher) {
          sheetWatcher.disconnect();
          sheetWatcher = null;
        }
      }

      if (!on || !bits.hero) {
        if (sheetWatcher) {
          sheetWatcher.disconnect();
          sheetWatcher = null;
        }
        if (bits.control.parentNode !== bits.sheet) bits.sheet.appendChild(bits.control);
        if (sheetHome && bits.sheet.parentNode !== sheetHome.parent && sheetHome.parent.isConnected) {
          sheetHome.parent.insertBefore(bits.sheet, sheetHome.next);
        }
        if (sheetHost && sheetHost.parentNode) sheetHost.parentNode.removeChild(sheetHost);
        sheetHost = null;
        return;
      }

      if (!sheetHome) {
        sheetHome = { sheet: bits.sheet, parent: bits.sheet.parentNode, next: bits.sheet.nextSibling };
      }
      var host2 = hostFor(bits.sheet, bits.hero);
      if (bits.sheet.parentNode !== host2) host2.appendChild(bits.sheet);
      dropStaleSheets(bits.sheet);

      tuckControl(bits);

      if (sheetWatcher || !window.MutationObserver) return;

      /* Het slot wisselt zijn inhoud bij elke opening; de knop moet dan weer in
         de kaart. tuckControl verplaatst zelf iets in dezelfde subtree, maar
         doet niets als het al goed staat, dus dat loopt niet rond. */
      sheetWatcher = new MutationObserver(function () {
        var now = sheetParts();
        if (!now || !now.slot || !now.control) return;
        tuckControl(now);
      });
      sheetWatcher.observe(bits.sheet, { childList: true, subtree: true });
    }

    /* ----------------------------------------------------------------------
       Pop stars staat stil zolang de kolom stilstaat

       In de opmaak begint pop stars pas ná het spoor van de kolom, dus zo lang
       die vast staat ligt hij een heel stuk scroll verderop. Op een hoog scherm
       — waar het eerste scherm bij zijn plafond ophoudt en de golf boven de
       onderkant van het venster staat — was het daaronder leeg tot de kolom
       klaar was.

       Dus plakt pop stars, net als de golf: in een omhulsel van nul hoog dat
       `sticky` op de onderrand van het eerste scherm staat (zie
       .pb-liquids-desk__stars in de stylesheet) en waar de sectie onderuit
       hangt. De browser houdt dat zelf stil, in dezelfde slag als het scrollen.
       Een eerdere versie schoof de sectie per scrollframe met een transform
       omhoog vanuit JS, en dat liep één frame achter: pop stars trilde bij elk
       scrollen. Daarom geen JS in de scrollslag meer.

       Wat JS nog wél doet: het omhulsel is nul hoog, dus neemt pop stars geen
       ruimte in de pagina in en zou de footer eronder omhoogkomen. main::after
       houdt die plek open met --pbdk-stars-height, en hoe hoog dat is weet
       alleen de browser — vandaar de ResizeObserver. Die vuurt bij een
       maatverandering, niet bij het scrollen.
       ---------------------------------------------------------------------- */

    var starsWatcher = null;

    function stars() {
      var shell = host.querySelector('[data-pbdk-stars]');
      var section = shell && shell.firstElementChild;

      if (!wide || !section) {
        host.style.removeProperty('--pbdk-stars-height');
        if (starsWatcher) {
          starsWatcher.disconnect();
          starsWatcher = null;
        }
        return;
      }

      /* Van de bovenrand van het omhulsel tot de onderkant van de sectie, en
         niet de hoogte van de sectie zelf: het paneel erin begint met een
         negatieve marge 47 boven de sectie (in het effen deel van de golf) en
         die marge valt door de sectiewrapper heen. Zo hoog als de sectie zou
         dus 47 te veel zijn, en dan stond er lucht boven de footer. */
      var write = function () {
        var top = shell.getBoundingClientRect().top;
        var bottom = section.getBoundingClientRect().bottom;
        host.style.setProperty('--pbdk-stars-height', Math.max(0, bottom - top) + 'px');
      };

      write();

      if (!starsWatcher && window.ResizeObserver) {
        starsWatcher = new ResizeObserver(write);
        starsWatcher.observe(section);
      }
    }

    /* ----------------------------------------------------------------------
       Schakelen
       ---------------------------------------------------------------------- */

    /* Alles hierin verdraagt herhaling, dus apply mag zo vaak aangeroepen
       worden als de editor of het breekpunt daar aanleiding toe geven. */
    /* De picker hoort te weten dat hij in de kolom staat: zijn gratis stap
       blijft dan op de pagina, vergrendeld, in plaats van zich te verbergen
       tot er iets verdiend is (zie `lockFree` in assets/pb-liquid-picker.js).
       Het attribuut voor een picker die nog gebouwd moet worden, de aanroep
       voor een die er al staat — in de editor komt beide voor. */
    function pickerMode(on) {
      var root = host.querySelector('[data-pblp-section]');
      if (!root) return;
      if (on) {
        root.setAttribute('data-pblp-desk', '');
      } else {
        root.removeAttribute('data-pblp-desk');
      }
      if (root.pbLiquidPicker && root.pbLiquidPicker.setDesk) root.pbLiquidPicker.setDesk(on);
    }

    function apply() {
      var scroll = wrap();

      wide = query.matches;
      measure();
      pickerMode(wide);
      clickMode(wide);
      sheetMode(wide);
      stars();
      fitLadder();

      /* De inhoud groeit als de picker een stap opent, en dan moet het spoor
         langer worden. Dat weet alleen de browser. */
      if (scroll && !watcher && window.ResizeObserver) {
        watcher = new ResizeObserver(measureTravel);
        watcher.observe(scroll);
      }

      measureTravel();
    }

    function onResize() {
      measure();

      /* De hoogte van de kolom hangt aan die van het venster, dus de maat van
         de ladder ook — en daarmee de lengte van het spoor. */
      fitLadder();
      measureTravel();
    }

    if (query.addEventListener) {
      query.addEventListener('change', apply);
    } else if (query.addListener) {
      query.addListener(apply);
    }

    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    host.addEventListener('focusin', onFocus);

    apply();

    /* De webfont verandert de hoogte van de navigatie nadat hij binnen is. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measure();
        fitLadder();
      });
    }

    return {
      apply: apply,
      destroy: function () {
        if (query.removeEventListener) {
          query.removeEventListener('change', apply);
        } else if (query.removeListener) {
          query.removeListener(apply);
        }

        window.removeEventListener('resize', onResize);
        window.removeEventListener('scroll', onScroll);
        host.removeEventListener('focusin', onFocus);

        if (watcher) {
          watcher.disconnect();
          watcher = null;
        }

        if (frame) {
          window.cancelAnimationFrame(frame);
          frame = 0;
        }

        clickMode(false);
        sheetMode(false);
        pickerMode(false);
        wide = false;
        fitLadder();
        document.documentElement.style.removeProperty('--pbdk-headroll');
        host.style.removeProperty('--pbdk-stars-height');
        if (starsWatcher) {
          starsWatcher.disconnect();
          starsWatcher = null;
        }
        host.classList.remove('pb-liquids-desk-ready');
        controllers.delete(section);
      },
    };
  }

  function init(root) {
    findSections(root).forEach(function (section) {
      if (controllers.has(section)) return;

      var controller = createController(section);
      if (controller) controllers.set(section, controller);
    });
  }

  function destroy(root) {
    findSections(root).forEach(function (section) {
      var controller = controllers.get(section);
      if (controller) controller.destroy();
    });
  }

  /* De editor laadt of verplaatst een sectie: de ladder en de picker staan dan
     weer naast het witte vlak in plaats van erin, dus opnieuw inpakken. Ook als
     het de ladder of de picker zelf is die opnieuw geladen wordt — die krijgt
     dan een nieuw element, en het oude zat in het scrollvak. */
  function refresh() {
    var section = document.querySelector('[data-pbdk-section]');
    var controller = section && controllers.get(section);

    if (controller) {
      controller.apply();
    } else {
      init(document);
    }
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    refresh();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  document.addEventListener('shopify:section:reorder', refresh);

  window.PBLiquidsDesk = {
    init: init,
    destroy: destroy,
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init(document);
      },
      { once: true }
    );
  } else {
    init(document);
  }
})();
